<template>
  <v-main>
    <v-container>
      <v-layout class="justify-center" wrap>
        <v-flex sm12 md8>
          <v-card 
            class="pa-2 ml-4 mr-4" 
            elevation="4" 
            light 
            tag="section" 
            v-if="!loading">
            <v-card-title>

              <v-row class="row-card" v-if="!$vuetify.breakpoint.xs">
                <v-col cols="12" xl="9" md="9" sm="6" xs="6">
                  <h3 class="headline">
                    {{ platformName }}
                  </h3>
                </v-col>
                <v-col cols="12" xl="3" md="3" sm="6" xs="6">
                  <v-img 
                    :alt="platformName" 
                    class="mr-3" 
                    contain 
                    height="48px" 
                    position="center right" 
                    :src="require('@/assets/icons/unl.png')">
                  </v-img>
                </v-col>
              </v-row>

              <v-row class="row-card" v-if="$vuetify.breakpoint.xs">
                <v-col cols="12" xs="12" align="center">
                  <v-img 
                    :alt="platformName"  
                    contain 
                    height="96px" 
                    :src="require('@/assets/icons/unl.png')">
                  </v-img>

                  <h3 class="headline">
                    {{ platformName }}
                  </h3>
                </v-col>
              </v-row>
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>
              <p>Postulación de proyectos para la <b>{{ convocation.name }}</b></p>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outline
                    label="Título idea"
                    type="text"
                    v-model="title">
                  </v-text-field>
                </v-col>

                <v-col cols="12" xl="4" md="4" sm="12">
                  <v-text-field
                    outline
                    label="Nombre"
                    type="text"
                    v-model="name">
                  </v-text-field>
                </v-col>

                <v-col cols="12" xl="4" md="4" sm="12">
                  <v-text-field
                    outline
                    label="Apellido"
                    type="text"
                    v-model="lastname">
                  </v-text-field>
                </v-col>

                <v-col cols="12" xl="4" md="4" sm="12">
                  <v-text-field
                    outline
                    label="Celular"
                    type="text"
                    v-model="phone_number">
                  </v-text-field>
                </v-col>

                <v-col cols="12" xl="4" md="4" sm="12">
                  <v-text-field
                    outline
                    label="Correo electrónico"
                    type="text"
                    v-model="email">
                  </v-text-field>
                </v-col>

                <v-col cols="12" xl="4" md="4" sm="12">
                  <v-text-field
                    outline
                    label="Contraseña"
                    type="password"
                    v-model="password">
                  </v-text-field>
                </v-col>

                <v-col cols="12" xl="4" md="4" sm="12">
                  <v-text-field
                    outline
                    hide-details
                    label="Confirmar contraseña"
                    type="password"
                    v-model="confirm_password">
                  </v-text-field>
                </v-col>

                <v-col 
                  cols="12" 
                  class="d-flex align-center"
                  v-if="convocation.terms_and_conditions">
                  <!-- Checkbox -->
                  <v-checkbox
                    v-model="aceptaTerminos"
                    hide-details
                    class="mb-5"
                  ></v-checkbox>

                  <!-- Texto y enlace -->
                  <span>
                    ACEPTO
                    <a
                      href="#"
                      @click.prevent="dialog_terms_conditions = true"
                      class="blue--text"
                    >
                      TÉRMINOS Y CONDICIONES
                    </a>
                  </span>
                </v-col>

              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
              <v-row>
                <v-col cols="12" xl="6" md="6" sm="6" xs="12">
                  <v-btn 
                    color="info" 
                    :block="$vuetify.breakpoint.xs" 
                    small
                    outlined
                    :loading="loading_btn" 
                    :to="{ name: 'index'}">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Volver
                  </v-btn>
                </v-col>

                <v-col cols="12" xl="6" md="6" sm="6" xs="12" class="d-flex justify-end">
                  <v-btn 
                    color="info" 
                    :block="$vuetify.breakpoint.xs" 
                    :large="$vuetify.breakpoint.smAndUp" 
                    :loading="loading_btn" 
                    :disabled="!aceptaTerminos"
                    v-if="convocation.terms_and_conditions"
                    @click="fieldsValidate()">
                    <v-icon left>lock</v-icon>
                    Registrarse
                  </v-btn>

                  <v-btn 
                    color="info" 
                    :block="$vuetify.breakpoint.xs" 
                    :large="$vuetify.breakpoint.smAndUp" 
                    :loading="loading_btn" 
                    v-if="!convocation.terms_and_conditions"
                    @click="fieldsValidate()">
                    <v-icon left>lock</v-icon>
                    Registrarse
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-snackbar
      max-width="440"
      v-model="snackbar"
      :vertical="true">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="error_dialog"
      persistent
      max-width="490">
      <v-card>
        <v-card-title class="text-h5 font-weight-regular">
          Atención
        </v-card-title>
        <v-card-text>
          <label v-for="error in errors" :key="error">{{ error }}<br></label>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="error_dialog = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal con términos y condiciones -->
    <v-dialog
      v-model="dialog_terms_conditions"
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline">Términos y Condiciones</v-card-title>
        <v-card-text v-html="parsedTermsConditions"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog_terms_conditions = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'PostulateProject',
  props: {
    source: String,
  },
  data: () => ({
    loading:true,
    loading_btn: false,
    error_dialog:false,
    snackbar:false,
    text:'',
    darkTheme: true,
    slug:null,
    edition_id: null,
    convocation:[],
    platformName:'JIJE',

    title: '',
    name:'',
    lastname:'',
    email:'',
    phone_number: '',
    password: '',
    confirm_password: '',

    aceptaTerminos: false,
    dialog_terms_conditions: false,

    errors:[],
    emailRules: [ 
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)
    ],
    passwordRules: [ 
          v => !!v || "El campo es requerido",
          v => ( v && v >= 8 ) || "La contraseña debe tener al menos 5 caracteres",
          v => ( v && v <= 25 ) || "La contraseña no debe tener mas de 50 caracteres",
      ],
  }),
  computed: {
    ...mapGetters([
      'isLogged', 'user'
      ]),
    parsedTermsConditions() {
      const terms = this.convocation.terms_and_conditions || '';
      return terms
        .replace(/ql-align-center/g, 'text-center')
        .replace(/ql-align-right/g, 'text-right')
        .replace(/ql-align-left/g, 'text-left')
        .replace(/ql-align-justify/g, 'text-justify');
    }
  },
  methods: {
    async register() {
      this.loading_btn=true

      try {
        const response = await axios.post('/register', { 
            edition_id: this.convocation.id,
            name: this.name,
            lastname: this.lastname,
            title: this.title,
            email: this.email,
            phone_number: this.phone_number,
            password: this.password,
        });

        console.log('Respuesta del servidor: ', response.data);

        this.text = 'Gracias por registrarte, ahora ya puedes iniciar sesion.';
        this.snackbar = true;
        this.loading_btn = false;

        setTimeout(() => {
            this.$router.push({ name: 'login' }) 
        }, 2000);

      } catch (error) {
        this.text = error.response.data.error;
        this.snackbar = true;
        this.loading_btn = false;
      }
    },

    fieldsValidate(){
      this.errors = []
      if(this.title.length==0){
        this.errors.push('- Por favor ingrese el título de la idea (podrá cambiarlo luego si deseas)')
      }
      if(this.name.length==0){
        this.errors.push('- Por favor ingrese su nombre.')
      }
      if(this.lastname.length==0){
        this.errors.push('- Por favor ingrese su apellido.')
      }
      if(this.phone_number.length==0){
        this.errors.push('- Por favor ingrese su número de celular.')
      }
      if(!this.validateEmail(this.email)){
        this.errors.push('- El correo electrónico ingresado no es valido.')
      }
      if(this.password.length<8){
        this.errors.push('- La contraseña debe tener al menos 8 caracteres')
      }
      if(this.confirm_password!=this.password){
        this.errors.push('- Las contraseñas no coinciden')
      }
      if(this.errors.length==0){
        this.register()
      }else{
        this.error_dialog = true
      }
    },

    validateEmail(email) {
      var re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i 
      return re.test(email);
    },

    cheakIsLogin(){
      if(this.isLogged){
        this.$router.push({ name: 'HandleConvocationLogin' })
      }
    },

    async getInfoEdition(){
      await axios.get('index/convocation/'+this.slug).then(response =>{
        if(!response.data.convocation){
          this.$router.push({ name: 'HandleConvocationLogin' })   
          this.loading=false
        }else{
          this.convocation = response.data.convocation
          this.loading=false
        }
        
      }).catch(error => {
        console.log(error)
        if(error.response.status===404){
          this.$router.push({ name: 'UNLPotencia' })  
        }
      })
    },
  },
  created(){
    this.slug = this.$route.params.slug
    window.scrollTo(0,0);
    this.cheakIsLogin();
    this.getInfoEdition();
  }
};
</script>
<style scoped>
  .v-btn,
  .v-card {
    border-radius: 4px;
  }

  .v-main2 {
    background-color: lightcyan;
  }
  .row-card {
    width: 100%;
  }
</style>